/**
 * @generated SignedSource<<0ad010ff68a76e2b1dba70a612a53b6a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
export type GoalScoringMode = "OKR" | "SIMPLE";
export type NavV4EnrollmentState = "ENROLLED" | "PENDING" | "UNENROLLED";
export type WorkspaceType = "GLOBAL_EXPERIENCE" | "PRODUCT";
import type { FragmentRefs } from "relay-runtime";
export type storeHomeWorkspace$data = {
  readonly activationId: string | null;
  readonly cloudId: string;
  readonly goalScoringMode: GoalScoringMode;
  readonly id: string;
  readonly keyPrefix: string;
  readonly name: string;
  readonly navV4Enrollment: NavV4EnrollmentState | null;
  readonly timezone: string;
  readonly type: WorkspaceType;
  readonly uuid: string;
  readonly " $fragmentType": "storeHomeWorkspace";
};
export type storeHomeWorkspace$key = {
  readonly " $data"?: storeHomeWorkspace$data;
  readonly " $fragmentSpreads": FragmentRefs<"storeHomeWorkspace">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "storeHomeWorkspace"
};

(node as any).hash = "1e1c5369aafb7db13f584ea59844e392";

export default node;
